"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsCurrencyValidator {
    constructor(options) {
        this.options = options;
    }
    isValid(input) {
        if (input) {
            return validatorJS.isCurrency(input, this.options);
        }
        return false;
    }
}
exports.IsCurrencyValidator = IsCurrencyValidator;
//# sourceMappingURL=IsCurrencyValidator.js.map